// 该文档为官网国际化语言-中文
const zh = {
  setting:{
    languageType:'中文',
    serviceHotline:'服务热线',
    officialWechat:'官方微信',
    companyName:'飞坦(深圳)数字物流科技有限公司',
    companyCopyrightText:'版权声明 ©2020-2023 飞坦(深圳)数字物流科技有限公司 版权所有',
    companyAddress:'深圳市龙华区五和大道雅宝路1号星河World D栋6E',
    companyNews:'公司新闻',
    companyProfile:'飞坦数字物流，创始团队拥有十余年中东跨境物流管理经验，原阿里资深产品专家领衔提供技术支持，坚持用科技赋能物流，通过自主研发的数字化管理系统，依托大数据智能解析，实现高危订单拦截，物流路由动态切换，实时跨境回款等增值服务，整合链路优质资源，自营清关渠道，自建中东海外仓，自有本土派送团队，致力干跨境中东的头程物流、进口清关、海处仓、本地配送等全链路服务，为中东跨境商家提供稳定、高效的物流体验，赋能商家掘金中东。'
  },
  // 顶部菜单
  topItem:{
    home:'首页',
    serviceItem:{
      title:'核心业务',
      serviceOne:'FBA/FBN专线',
      serviceTwo:'空运/海运门到门',
      serviceThree:'海外仓',
      serviceFour:'海运整柜清关',
      serviceFive:'Saber证书',
      serviceSix:'B2C小包',
    },
    tracking:'物流追踪',
    news:'新闻资讯',
    aboutUsItem:{
      title:'关于我们',
      contentOne:'公司简介',
      contentTwo:'发展历程',
      contentThree:'合作单位',
      contentFour:'联系我们',
    },
    login:'登录',
  },
  // 滚动横幅
  bannerItem:{
    itemOne:{
      text:'闯中东 选',
      subText:'飞坦',
      lastText:'',
      contentOne:{
        text:'飞坦数字物流',
        subText:'',
        lastText:'',
      }
    },
    itemTwo:{
      text:'亚马逊SPN服务商',
      subText:'',
      lastText:'',
      contentOne:{
        text:'中东全链路服务商',
        subText:'',
        lastText:'',
      }
    },
    itemThree:{
      text:'空运时效',
      subText:'5-7',
      lastText:'天',
      contentOne:{
        text:'海运时效',
        subText:'35',
        lastText:'天',
      }
    },
    itemFour:{
      text:'自营海外仓',
      subText:'飞坦',
      lastText:'',
      contentOne:{
        text:'FBA/FBN仓储中转',
        subText:'',
        lastText:'',
      },
      contentTwo:{
        text:'一件代发',
        subText:'',
        lastText:'',
      },
      contentThree:{
        text:'整箱上架/分拣上架',
        subText:'',
        lastText:'',
      },
      contentFour:{
        text:'二次送仓',
        subText:'',
        lastText:'',
      },
      contentFive:{
        text:'RTO退货换标',
        subText:'',
        lastText:'',
      }
    },
    itemFive:{
      text:'自主研发系统',
      subText:'',
      lastText:'',
      contentOne:{
        text:'库存信息可视化',
        subText:'',
        lastText:'',
      },
      contentTwo:{
        text:'物流轨迹透明化',
        subText:'',
        lastText:'',
      },
      contentThree:{
        text:'下达指令电子化',
        subText:'',
        lastText:'',
      },
    },

  },
  // 核心业务
  mainServiceItem:{
    titlePartOne:'核心',
    titlePartTwo:'业务',
    serviceOne:{
      title:'中东FBA/FBN专线',
      contentOne:'空运时效5-7，海运时效约35天',
      contentTwo:'FBA免预约送仓，FBN送仓成功率高',
      detailOne:{
        content:'中东FBA/FBN专线，渠道稳定，时效有保障'
      },
      detailTwo:{
        content:'亚马逊SPN服务商，FBA免预约送仓'
      },
      detailThree:{
        content:'丰富的NOON送仓经验，FBN送仓成功率高'
      },
    },
    serviceTwo:{
      title:'空运/海运门到门',
      contentOne:'提供中东本地收货人、报关、清关、SABER证书、本地派送、回款等全套物流服务',
      detailOne:{
        title:'沙特空运时效：',
        content:'5-7天'
      },
      detailTwo:{
        title:'沙特海运时效：',
        content:'35-40天'
      },
      detailThree:{
        title:'阿联酋空运时效：',
        content:'8-12天'
      },
      detailFour:{
        title:'阿联酋海运时效：',
        content:'28-35天'
      },
    },
    serviceThree:{
      title:'海外仓',
      contentOne:'中东自营海外仓(沙特/阿联酋)',
      contentTwo:'提供FBA/FBN暂存转运、一件代发、退货换标等全方位服务',
      detailOne:{
        title:'中东网络：',
        content:'自营沙特/阿联酋海外仓'
      },
      detailTwo:{
        title:'规模领先：',
        content:'面积近10000平方米，可容纳1200+个标准托盘，设有10000+个电商库位'
      },
      detailThree:{
        title:'合规安全：',
        content:'海外仓全套合规认证，合法雇佣劳工，确保客户货物安全保障'
      },
      detailFour:{
        title:'服务内容：',
        content:'提供FBA/FBN暂存转运、一件代发、退货换标等全方位服务'
      },
    },
    serviceFour:{
      title:'海运整柜清关',
      contentOne:'自有清关行，专业的清关团队',
      contentTwo:'丰富的证书清关经验，提供多种清关方案',
      detailOne:{
        content:'自有清关行，提供多种清关方案'
      },
      detailTwo:{
        content:'专业的清关团队，丰富的证书清关经验'
      },
    },
    serviceFive:{
      title:'Saber证书',
      contentOne:'Saber注册，快速注册',
      contentTwo:'SC可当天出证',
      detailOne:{
        content:'丰富的证书制作经验，快速匹配产品及对应证书'
      },
      detailTwo:{
        content:'发证速度快，SC可当天出证'
      },
    },
    serviceSix:{
      title:'B2C小包',
      contentOne:'自有海外仓+成熟本土派送团队，签收率高，时效快，提供COD解决方案',
      detailOne:{
        content:'签收率高，时效快'
      },
      detailTwo:{
        content:'自有海外仓+成熟本土派送团队'
      },
      detailThree:{
        content:'提供COD解决方案'
      },
    },
  },
  // 服务优势
  serviceAdvantageItem:{
    titlePartOne:'服务',
    titlePartTwo:'优势',
    countData:{
      titleOne:'合作方数量',
      titleTwo:'服务客户数量',
      titleThree:'仓储面积',
      titleFour:'平均签收率',
    },
    adOne:{
      title:'强科技 优系统',
      content:'自主研发的数字化管理系统，<strong>实现高危订单拦截，物流路由动态切换，实时跨境回款等增值服务，</strong>优化物流全链路，提升物流时效，加强货物安全监管，降低物流成本',
    },
    adTwo:{
      title:'广增值 全赋能',
      content:'借助大数据分析，定期输出服务追踪反馈，反向赋能，帮助客户提升妥投率，为客户决策提供全方位依据',
    },
    adThree:{
      title:'渠道稳 时效快',
      content:'一手资源，仓位稳定，<strong>空派时效5-7天，FBA/FBN全程时效8-10天（含送仓）</strong>',
    },
    adFour:{
      title:'专业高 出证快',
      content:'自有清关渠道，专业清关团队，提供中东收货人和全套物流解决文案，SABER注册，快速出证，SC可当天出证',
    },
    adFive:{
      title:'妥投高 回款快',
      content:'自建海外仓，自有本土派送团队，<strong>COD妥投率高，周结回款，</strong>加快资金周转，降低资金风险',
    },
    adSix:{
      title:'重安全 有保障',
      content:'重视货物安全，通过数字系统实时跟踪物流轨迹，每个环节都有据可查',
    },
  },
  // 轨迹追踪
  trackingItem:{
    title:'物流追踪',
    search:'查询',
    searching:'查询中',
    searchTips:'请输入Fleetan订单号查询轨迹',
    inputTips:'请先输入订单号',
    orderNo:'订单号',
    noResultTips:'未能查询到轨迹信息',
    noTrackingTips:'暂无轨迹信息',
    searchError:'查询轨迹出错，请联系客服咨询',
    batch:'批次',
    batchInfo:'批次信息',
    appointmentTime:'预约送仓时间',
  },

  // 新闻资讯
  newsItem:{
    titlePartOne:'新闻',
    titlePartTwo:'资讯',
    checkDetail:'查看详情',
  },
  // 合作伙伴
  partnersItem:{
    titlePartOne:'合作',
    titlePartTwo:'伙伴',
  },
  // 关于我们
  aboutUsItem:{
    companyIdea:{
      title:'公司理念',
      ideaOne:'客户第一(服务)',
      ideaTwo:'团队合作(共赢)',
      ideaThree:'诚实守信(诚信)',
      ideaFour:'拥抱变化(乐观)',
    },
    courseList:{
      listOne:{
        title:'公司成立',
        content:'以助力国货 物畅全球为使命，为跨境电商企业提供全程可视稳定可控的全球一站式物流解决方案以助力国货 物畅全球为使命，为跨境电商企业提供全程可视稳定可控的全球一站式物流解决方案'
      },
      listTwo:{
        title:'建立义乌办事处'
      },
      listThree:{
        title:'飞坦海外仓落地沙特'
      },
      listFour:{
        title:'海运上线'
      },
      listFive:{
        title:'飞坦成为Amazon Seller Flex项目指定合作海外仓之一'
      },
      listSix:{
        title:'飞坦成立两周年'
      },
      listSeven:{
        title:'飞坦正式成为亚马逊自发货VTR授权服务商'
      },
      listEight:{
        title:'开通阿联酋专线'
      },
      listNine:{
        title:'飞坦华南操作中心正式成立'
      },
      listTen:{
        title:'飞坦正式成为亚马逊SPN服务商'
      }
    },
    contactInfo:{
      contactTitle:'请联系我们',
      contactSubTitle:'我们将根据您的需求提供更优质物流方案',
      cnPartTitle:'国内业务部',
      saPartTitle:'沙特分部',
      uaePartTitle:'阿联酋分部',
      name:'姓名',
      email:'邮箱',
      phone:'手机',
      address:'地址',
      formTitle:'欢迎您的留言',
      contactType:'联系方式',
      leaveWord:'留言',
      submit:'提 交',
      reset:'重 置'
    }
  }

}
export default zh;



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js